import React from 'react';
import ApplicantForm from '../../components/ApplicantForm';
import { useNavigate } from 'react-router-dom';

const ApplicantCreate = () => {
  const navigate = useNavigate();

  // Handle successful form submission
  const handleSuccess = () => {
    navigate('/applicants/applicantlist'); // Redirect to the applicant list after successful submission
  };

  return (
    <div>
      <ApplicantForm onSuccess={handleSuccess} />
    </div>
  );
};

export default ApplicantCreate;